<template>
  <div id="app">
    <onHead
      @urerId="getCreateId"
      @getUrl="getUrl"
      @gettabSt="gettabSt"
      @Collapse="Collapse"
      :navUrl="navUrl"
    ></onHead>
    <div class="disBox">
      <Navtab
        :tabSt="tabSt"
        :getFun="getFun"
        @getUrl="getUrl"
        :isCollapse="isCollapse"
      ></Navtab>
      <transition>
        <div class="content-scroll scrollbar">
          <router-view
            @gettabSt="gettabSt"
            @getAjax="getAjax"
            :createId="createId"
            :navUrl="navUrl"
          ></router-view>
        </div>
      </transition>
    </div>
    <!--<transition>-->
    <!--<router-view></router-view>-->
    <!--</transition>-->
  </div>
</template>

<script>
import Navtab from "./components/Navtab";
import onHead from "./components/onHead";
export default {
  name: "App",
  components: {
    Navtab,
    onHead,
  },
  data() {
    return {
      tabSt: "",
      createId: "",
      navUrl: "",
      getFun: "",
      isCollapse: false,
    };
  },
  watch: {
    $route(to, from) {
      document.title = this.$route.meta.title || this.$route.name;
    },
  },
  methods: {
    gettabSt(e) {
      this.tabSt = e;
    },
    getCreateId(e) {
      this.createId = e;
    },
    getUrl(e) {
      this.navUrl = e;
    },
    getAjax(e) {
      this.getFun = e;
    },
    Collapse() {
      this.isCollapse = !this.isCollapse;
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body,
html {
  min-height: 100vh;
  width: 100%;
}
#app {
  min-height: 100vh;
  width: 100%;
  font-family: "MicrosoftYaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.content-scroll {
  display: block;
  width: 100%;
  height: calc(100vh - 80px);
  overflow-y: auto;
}
.disBox {
  display: flex;
}
/* .v-modal{
  z-index: 1 !important;
  display: none !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue